import ReactGA from 'react-ga4';
import { getEnv } from '../helper/get-env';
import generateClientIdGa from '../helper/generate-client-id-ga';

export const gaEnvKey = 'GOOGLE_ANALYTICS_TRACKING_ID';

const ga = {
    async initGoogleAnalytics() {
        ReactGA.initialize([
            {
                trackingId: await getEnv(gaEnvKey, true),
                gaOptions: {
                    anonymizeIp: true,
                    clientId: generateClientIdGa()
                }
            }
        ]);
    }
};

export default ga;
